import { render, staticRenderFns } from "./IDelete.vue?vue&type=template&id=62615e2c&scoped=true&"
import script from "./IDelete.vue?vue&type=script&lang=js&"
export * from "./IDelete.vue?vue&type=script&lang=js&"
import style0 from "./IDelete.vue?vue&type=style&index=0&id=62615e2c&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62615e2c",
  null
  
)

export default component.exports